module.exports = __webpack_public_path__ + "img/tutor-image-ico.9309aae7.svg";